/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../components.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class ServiceAdvisorSelectDirectiveController {
        public static $inject: string[] = [
            '$scope',
            '$dealerwareNotification',
            '$mobilityCompanyAuthentication',
            'DealerwareEmployeeModel'
        ];

        public serviceAdvisorId: any;
        public serviceAdvisorName: string;
        public required: boolean;
        public serviceAdvisors: any;

        constructor(public $scope: any,
                    public $dealerwareNotification: any,
                    public $auth: any,
                    public DealerwareEmployeeModel: any) {
            this.DealerwareEmployeeModel.loadServiceAdvisors({
                promise: true,
                params: { location_id: this.$auth.location.id }
            }).then(
                (returnValue: any) => {
                    var serviceAdvisors: any = [],
                        serviceAdvisorsTracker: any = {};

                    returnValue.data.forEach((user: any) => {
                        if (!serviceAdvisorsTracker[user.id]) {
                            serviceAdvisors.push(user);
                            serviceAdvisorsTracker[user.id] = true;
                        }
                    });

                    this.serviceAdvisors = serviceAdvisors;
                },
                (response: any) => { this.$dealerwareNotification.apiError(response); }
            );

            this.$scope.$watch(() => {
                return this.serviceAdvisorName && this.serviceAdvisors ? true : false
            }, (ready: any) => {
                if (ready) {
                    if (!this.serviceAdvisors.find((sa: any) => sa.id === this.serviceAdvisorId)) {
                        this.serviceAdvisors.push({
                            id: this.serviceAdvisorId,
                            user_profile: { full_name: this.serviceAdvisorName }
                        });
                    }
                }
            });
        }
    }

    getDealerwareWebComponentsModule().controller('ServiceAdvisorSelectDirectiveController', ServiceAdvisorSelectDirectiveController);

    export class ServiceAdvisorSelectDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'ServiceAdvisorSelectDirectiveController';
        public controllerAs     : string    =   'serviceAdvisorSelectController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            serviceAdvisorId: '=',
            serviceAdvisorName: '=?',
            required: '='
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/service_advisor_select/service_advisor_select_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {
        }

    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareServiceAdvisorSelect",() => new ServiceAdvisorSelectDirective());
}
